import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=617576c0&scoped=true&"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuItem.vue?vue&type=style&index=0&id=617576c0&prod&scoped=true&lang=css&"
import style1 from "./VerticalNavMenuItem.vue?vue&type=style&index=1&id=617576c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617576c0",
  null
  
)

export default component.exports